import { render, staticRenderFns } from "./TabContent1.vue?vue&type=template&id=622f2774"
import script from "./TabContent1.vue?vue&type=script&lang=js"
export * from "./TabContent1.vue?vue&type=script&lang=js"
import style0 from "./TabContent1.vue?vue&type=style&index=0&id=622f2774&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports